// extracted by mini-css-extract-plugin
export default {"list":"ForcedModifiersModalList_list__Sec6v"};